import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig, refineHeader } from "../../config";
import auth from "../auth";

export const userService = {
  login,
  logout,
  superAdminLogin,
  forgot_Passsword,
  getLoginDetailByToken,
  reset_Passsword,
};

function login(email, password) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ email, password }),
  };

  return fetch(`${appConfig.api.url}login`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user.result.token));
      localStorage.setItem("userTypeName", user.result.userTypeName);
      localStorage.setItem("user_id", user.result.user_id);
      localStorage.setItem("userTypeID", user.result.userTypeID);
      localStorage.setItem("siteID", user.result.siteID);
      localStorage.setItem("user_sec_id", user.result.user_sec_id);

      auth.setToken(user.result.token);
      const {
        status,
        firstName,
        lastName,
        userName,
        userTypeName,
        user_id,
        email,
        siteID,
        user_permissions,
        user_sec_id,
      } = user.result;
      const userdata = {
        status,
        firstName,
        lastName,
        userName,
        userTypeName,
        user_id,
        email,
        siteID,
        user_permissions,
        user_sec_id,
      };
      auth.setUserInfo(userdata);
      return user;
    });
}

function superAdminLogin(userid, usertype) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ userid, usertype }),
  };

  return fetch(`${appConfig.api.url}login`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      localStorage.setItem("user", JSON.stringify(user.result.token));
      localStorage.setItem("userTypeName", user.result.userTypeName);
      localStorage.setItem("user_id", user.result.user_id);
      localStorage.setItem("userTypeID", user.result.userTypeID);
      localStorage.setItem("siteID", user.result.siteID);
      localStorage.setItem("user_sec_id", user.result.user_sec_id);
      auth.setToken(user.result.token);
      const {
        status,
        firstName,
        lastName,
        userName,
        user_id,
        userTypeName,
        user_sec_id,
      } = user.result;
      const userdata = {
        status,
        firstName,
        lastName,
        userName,
        user_id,
        userTypeName,
        user_sec_id,
      };
      auth.setUserInfo(userdata);
      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}logout`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      // if (user.token) {
      //     // store user details and jwt token in local storage to keep user logged in between page refreshes
      //     localStorage.setItem('user', JSON.stringify(user));
      // }
      auth.clearAllAppStorage();
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");
      localStorage.removeItem("userTypeName");
      localStorage.removeItem("userTypeID");
      localStorage.removeItem("siteID");
      localStorage.removeItem("user_sec_id");
      return user;
    });
}

function forgot_Passsword(postData) {
  // remove user from local storage to log user out
  //refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}password/create`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function reset_Passsword(postData) {
  // remove user from local storage to log user out
  //refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}reset`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getLoginDetailByToken(tokenIdParams) {
  //refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(
    `${appConfig.api.url}password/find/${tokenIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/userService.js